module.exports = __webpack_public_path__ + "files/857b5a3323890556286345299d9a109e.gif";